<template>
  <div class="template-library-wrapper">
    <TemplateLibraryV2
      v-if="canUseReleaseNewDiscoverTemplates"
      v-aha-emit-action.view
      name="TemplateLibraryV2"
    />
    <TemplateLibrary
      v-else
      v-aha-emit-action.view
      name="TemplateLibrary"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import TemplateLibrary from '@/components-v2/template-library/v2/TemplateLibrary'
import TemplateLibraryV2 from '@/components-v2/template-library/v2/TemplateLibrary.v2'

export default {
  components: {
    TemplateLibrary,
    TemplateLibraryV2,
  },
  computed: {
    ...mapGetters('featureToggles', ['canUseReleaseNewDiscoverTemplates']),
  },
}
</script>
